import React, { useRef, useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import {
	Box,
	Button,
	Grid,
	Typography,
	Pagination,
	FormControl,
	Select,
	MenuItem,
} from "@mui/material";
import CourseCard from "../../Pages/HomePage/LearningCard";
import {
	getCoursesByHub,
	getLearnerCourses,
	getAllCourses,
} from "../../Redux/CourseDetails";
import { fetchFoundationStatus } from "Redux/LearnersReport";
import "./Carousel.css";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import { getCoursesGroupedCourses, isFoundationUnlocked } from "utils/foundationUnlock";

const getItemsPerPage = () => (window.innerWidth > 1400 ? 5 : 4);
const ITEMS_PER_PAGE = getItemsPerPage();
// const ITEMS_PER_PAGE = 4;

/* 🔹 Image Pool */
const courseImg = [
	{ img: "/Assets/One.jpg" },
	{ img: "/Assets/Two.jpg" },
	{ img: "/Assets/Three.jpg" },
	{ img: "/Assets/Four.jpg" },
	{ img: "/Assets/Five.jpg" },
	{ img: "/Assets/One.jpg" },
	{ img: "/Assets/Two.jpg" },
	{ img: "/Assets/Three.jpg" },
	{ img: "/Assets/Four.jpg" },
];

/* 🔹 Stable random image selector */
const getRandomImageForCourse = (courseId) => {
	const index = courseId % courseImg.length;
	return courseImg[index];
};

/* 🔹 Date helpers */
const isOverdue = (date) => {
	if (!date) return false;
	const today = new Date();
	const dueDate = new Date(date);
	return dueDate < today;
};

const isDueThisMonth = (date) => {
	if (!date) return false;
	const today = new Date();
	const dueDate = new Date(date);
	return (
		dueDate.getMonth() === today.getMonth() &&
		dueDate.getFullYear() === today.getFullYear()
	);
};

const LearningCarousel = () => {
	const dispatch = useDispatch();
	const scrollRef = useRef(null);
	const { instance } = useMsal();
	const [userLevel, setUserLevel] = useState(null);
	const [userName, setUserName] = useState(null);

	const userData = useSelector((state) => state.userDetails.userData[0]);

	const {
		courseList,
		loader,
		// inProgressCourses,
		// completedCourses,
		allCourses,
		coursesByHub
	} = useSelector((state) => state.courseDetails);

	const isFoundationCompleted = isFoundationUnlocked({
		coursesByHub,
		userData,
		userLevel,
	});

	const [activeTab, setActiveTab] = useState("inProgress");
	const [selectedHub, setSelectedHub] = useState("");
	const [page, setPage] = useState(1);

	/* 🔽 FILTER STATE (NO FILTER BY DEFAULT) */
	const [filterBy, setFilterBy] = useState("");

	/* 🔄 Reset filter & page on tab change */
	useEffect(() => {
		setFilterBy("");
		setPage(1);
	}, [activeTab]);

	/* 📡 Fetch courses */
	useEffect(() => {
		const account = instance.getActiveAccount();
		if (!account) return;

		const enterpriseId = account.idTokenClaims.enterpriseID;
		const userLevelDes = account.idTokenClaims.jobFamilyDescription;
		const userName = account.idTokenClaims.givenName;
		setUserName(userName);
		setUserLevel(userLevelDes);
		dispatch(getAllCourses());
		dispatch(getLearnerCourses(enterpriseId));
		dispatch(fetchFoundationStatus(enterpriseId));
	}, [dispatch, instance]);

	// function includesValue(str, value) {
	// 	if (!str) return false;
	// 	if (str.trim().toLowerCase() === "all") return true;
	// 	if (!value) return false;

	// 	return str
	// 		.toLowerCase()
	// 		.split(",")
	// 		.map(v => v.trim())
	// 		.includes(value.toLowerCase());
	// }

	// function isLevelAllowed(label, level) {
	// 	if (!label || level == null) return false;
	// 	const normalizedLabel = label.toLowerCase();

	// 	if (normalizedLabel === "all") return true;

	// 	if (
	// 		typeof level === "string" &&
	// 		level.toLowerCase().includes("accenture leadership")
	// 	) {
	// 		return !normalizedLabel.includes("below");
	// 	}

	// 	const numericLevel = Number(level);
	// 	if (Number.isNaN(numericLevel)) return false;

	// 	if (normalizedLabel.includes("below")) {
	// 		const maxLevel = Number(normalizedLabel.match(/\d+/)?.[0]);
	// 		return numericLevel >= maxLevel;
	// 	}

	// 	if (normalizedLabel.includes("above")) {
	// 		return numericLevel < 7;
	// 	}
	// }

	// const mandatoryCourses = useMemo(() => {
	// 	if (!userData) return [];

	// 	const completedIds = new Set(
	// 		completedCourses?.map(c => c.id)
	// 	);

	// 	return allCourses?.filter((course) =>
	// 		course.courseType === "Mandatory"
	// 		&& isLevelAllowed(course.level, userLevel)
	// 		&& (
	// 			(
	// 				includesValue("Digital Customer", course.category)
	// 				&& includesValue(course.sub_category, userData.capability)
	// 			) ||
	// 			(
	// 				includesValue("Industry", course.category)
	// 				&& includesValue(course.sub_category, userData.industry)
	// 			) ||
	// 			(
	// 				includesValue("Technology", course.category)
	// 				&& includesValue(course.sub_category, userData.category)
	// 			) ||
	// 			(
	// 				includesValue(
	// 					"GenAI for TDLC,Full-Stack GenAI,Specialization in Solutioning,AI for Solutioning,Agentic AI for Solutioning, Reinvention with Agentic AI",
	// 					course.category
	// 				) &&
	// 				includesValue(course.capability, userData.capability) &&
	// 				includesValue(course.industry, userData.industry) &&
	// 				includesValue(course.role, userData.role)
	// 			)
	// 		)
	// 		&& !completedIds.has(course.id)
	// 	) || [];
	// }, [
	// 	allCourses,
	// 	userData,
	// 	completedCourses,
	// 	isFoundationCompleted,
	// 	userLevel
	// ]);

	let courses = [];

	coursesByHub?.forEach((hub) => {
		if (!isFoundationCompleted && hub.hubName !== "Foundation") {
			return;
		}

		const groupedCourses = getCoursesGroupedCourses({
			coursesByHub: [hub],
			userData,
			userLevel,
			hubName: hub.hubName
		});

		courses.push(...groupedCourses);
	});

	const hasEnrollment = (course) =>
		course?.enrollmentDate && course.enrollmentDate.trim() !== "";

	const hasCompletion = (course) =>
		course?.completionDate && course.completionDate.trim() !== "";

	const inProgressCourses = courses?.filter(
		(course) => hasEnrollment(course) && !hasCompletion(course)
	);

	const completedCourses = courses?.filter(
		(course) => hasEnrollment(course) && hasCompletion(course)
	);
	const mandatoryCourses = courses?.filter((course) =>
		course?.courseType === "Mandatory" &&
		!course?.enrollmentDate &&
		!course?.completionDate
	);

	const activeCourses = useMemo(() => {
		switch (activeTab) {
			case "inProgress":
				return inProgressCourses || [];
			case "mandatory":
				return mandatoryCourses;
			case "completed":
				return completedCourses || [];
			default:
				return [];
		}
	}, [activeTab, inProgressCourses, completedCourses, mandatoryCourses]);

	/* FILTER LOGIC */
	const filteredCourses = useMemo(() => {
		if (activeTab === "completed") return activeCourses;
		if (!filterBy) return activeCourses;
		if (filterBy === "overdue") {
			return activeCourses.filter((c) => isOverdue(c.dueDate));
		}
		if (filterBy === "thisMonth") {
			return activeCourses.filter((c) =>
				isDueThisMonth(c.dueDate)
			);
		}
		return activeCourses;
	}, [activeCourses, filterBy, activeTab]);

	/* Filter counts */
	const overdueCount = useMemo(() => {
		if (activeTab === "completed") return 0;
		return activeCourses.filter((c) => isOverdue(c.dueDate)).length;
	}, [activeCourses, activeTab]);

	const thisMonthCount = useMemo(() => {
		if (activeTab === "completed") return 0;
		return activeCourses.filter((c) =>
			isDueThisMonth(c.dueDate)
		).length;
	}, [activeCourses, activeTab]);

	/* Pagination */
	const totalPages = Math.ceil(filteredCourses.length / ITEMS_PER_PAGE);
	const paginatedCourses = filteredCourses.slice(
		(page - 1) * ITEMS_PER_PAGE,
		page * ITEMS_PER_PAGE
	);

	return (
		<div className="learning-wrapper">
			<h2 className="section-headings">My Learning</h2>

			<Box display="flex" justifyContent="space-between" alignItems="center">
				{/* TABS */}
				<Grid container className="learning-tabs">
					{["inProgress", "mandatory", "completed"].map((tab) => (
						<Button
							key={tab}
							className={activeTab === tab ? "active-tab" : "inactive-tab"}
							sx={{ m: 1, minWidth: 90 }}
							onClick={() => setActiveTab(tab)}
						>
							{tab === "inProgress"
								? "In Progress"
								: tab === "mandatory"
									? "Required "
									: "Completed"}
						</Button>
					))}
				</Grid>

				{/* RIGHT ACTIONS */}
				<Box display="flex" alignItems="center" gap={3}>
					{/* FILTER */}
					<Box display="flex" alignItems="center" gap={1}>
						<Typography className="sort-label">Sort By</Typography>

						<FormControl size="small" className="sort-pill">
							<Select
								value={filterBy}
								displayEmpty
								disabled={activeTab === "completed"}
								onChange={(e) => setFilterBy(e.target.value)}
								renderValue={(selected) => {
									if (!selected) return "Filter";
									return selected === "overdue"
										? `Overdue (${overdueCount})`
										: `Due this month (${thisMonthCount})`;
								}}
							>
								<MenuItem value="">
									<em>None</em>
								</MenuItem>
								<MenuItem value="overdue">
									Overdue ({overdueCount})
								</MenuItem>
								<MenuItem value="thisMonth">
									Due this month ({thisMonthCount})
								</MenuItem>
							</Select>
						</FormControl>
					</Box>

					{/* EXPLORE */}
					<Link to="/learningHubs" className="learning-explore-link">
						<Button
							startIcon={<ArrowForwardIcon />}
							sx={{
								background: "transparent",
								color: "#000",
								boxShadow: "none",
								fontWeight: 600,
								"&:hover": { background: "transparent" },
							}}
						>
							Explore All
						</Button>
					</Link>
				</Box>
			</Box>

			{/* COURSE LIST */}
			<Box mt={3}>
				{loader ? (
					<Typography mt={3}>Loading...</Typography>
				) : paginatedCourses.length ? (
					<Box ref={scrollRef} display="flex" gap={3} flexWrap="wrap">
						{paginatedCourses.map((course) => (
							<CourseCard
								key={course.id}
								course={course}
								courseImg={getRandomImageForCourse(course.id)}
								courseType={activeTab === "completed" && "completed"}
								path="homepage"
							/>
						))}
					</Box>
				) : (
					<>
						<div className="noCoursesWrap">
							<img src={process.env.PUBLIC_URL + "/Assets/Home/noCoursesImg.png"} style={{ height: "5rem", marginRight: "1rem" }} />
							<div>
								<h4 style={{ paddingTop: "20px" }}>
									<b>
										Hey {userName}!{" "}
										{activeTab === "inProgress"
											? "You have no courses in progress yet!"
											: activeTab === "mandatory"
												? "You have no required courses yet!"
												: "You have not completed any learning yet!"}
									</b>
								</h4>
								<p>Please continue learning to earn Badges and Points</p>
							</div>
						</div>
					</>
				)}

				{/* PAGINATION */}
				{totalPages > 1 && (
					<Box display="flex" justifyContent="center" mt={4}>
						<Pagination
							count={totalPages}
							page={page}
							onChange={(e, value) => setPage(value)}
							color="primary"
							shape="rounded"
						/>
					</Box>
				)}
			</Box>
		</div>
	);
};

export default LearningCarousel;
